/* Standart storefront event/action köprüsü (Shopify, 17 Haziran 2026).

   NEDEN GEREKLİ — ölçümle tespit edildi:
   1. Shopify.actions.openCart() bu temada SESSİZCE HİÇBİR ŞEY YAPMIYORDU.
      Varsayılan uygulama <cart-drawer-component> üzerinde .open() arıyor;
      Horizon'un bileşeni ise DialogComponent'ten gelen showDialog() sunuyor.
      Sonuç: sepete ekleyip çekmeceyi açmak isteyen app veya yapay zekâ
      ajanı hiçbir tepki alamıyordu. configure() ile düzeltiliyor.
   2. Temanın kendi sepete-ekleme yolu yalnızca Horizon'un özel `cart:update`
      olayını yayıyor, standart shopify:cart:lines-update'i yaymıyordu — yani
      app'ler tema arayüzünden yapılan eklemeleri göremiyordu.
      Bu dosya, olayı doğru biçimde yaymak için petask-pills.js'e yardımcı verir.

   NOT: Shopify.actions.updateCart'ın VARSAYILANI bu temada zaten doğru
   çalışıyor (sayfayı yenilemiyor, standart olayı kendisi yayıyor, sepet
   rozetini güncelliyor) — bu yüzden bilerek configure EDİLMİYOR. Çalışan bir
   yolu gereksiz yere değiştirmek risk.

   Dokümantasyon: shopify.dev/docs/storefronts/themes/best-practices/standard-events
*/
import { CartLinesUpdateEvent, CartErrorEvent } from '@theme/standard-events';

/* petask-pills.js klasik script olduğu için modül içe aktarımı yapamıyor;
   ihtiyacı olan parçaları burada yayınlıyoruz. */
window.petaskStandardEvents = { CartLinesUpdateEvent, CartErrorEvent };

/* Yapılandırma {{ content_for_header }} öncesinde ve DOMContentLoaded içinde
   kaydedilmeli ki app kodu çalışmadan önce devreye girsin. */
document.addEventListener('DOMContentLoaded', () => {
  if (!window.Shopify?.actions?.openCart?.configure) return;

  window.Shopify.actions.openCart.configure({
    handler() {
      const drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.showDialog === 'function') {
        drawer.showDialog();
        return;
      }
      /* Çekmece yoksa varsayılan davranışa dön: sepet sayfası. */
      window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
    },
  });
});
